<!-- eslint-disable @angular-eslint/template/use-track-by-function -->
<form [formGroup]="componentForm" (ngSubmit)="emitSubmit()" class="flex-col flex-justify-center form-container" #ngForm="ngForm">
    @if (showPersonal() || showEmail()) {
    <div class="flex-col flex-justify-center flex-align-stretch form-group personal-infos-form-group" formGroupName="personalInfos">
        @if (showEmail()) {
        <div class="flex-row flex-justify-space-around flex-align-center form-group--row from-group--row-wrapper">
            <mat-form-field id="emailField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.email' | translate }}</mat-label>
                <input type="email" matInput placeholder="{{ 'dottnet.label.email' | translate }}" [formControl]="email" />
                @if (email.touched) {
                <mat-error>{{ errorMessage('personalInfos.email') }}</mat-error>
                }
            </mat-form-field>
        </div>
        @if (!user() || showPwd()) {
        <div class="flex-row flex-justify-space-around flex-align-center form-group--row from-group--row-wrapper">
            <mat-form-field id="passwordField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.password' | translate }}</mat-label>
                <input type="password" matInput placeholder="{{ 'dottnet.label.password' | translate }}" [formControl]="password" />
                <mat-hint>{{ 'dottnet.hint.password' | translate }}</mat-hint>
                <mat-error>{{ errorMessage('personalInfos.password') }}</mat-error>
            </mat-form-field>
        </div>
        }
        }
        @if (showPersonal()) {
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'dottnet.wall.anagrafica' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
        <div class="flex-row form-group--row name-surname-wrapper from-group--row-wrapper">
            <mat-form-field id="nameField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.name' | translate }}</mat-label>
                <input type="text" matInput placeholder="{{ 'dottnet.label.name' | translate }}" [formControl]="name" color="primary" />
                <mat-error>{{ errorMessage('personalInfos.name') }}</mat-error>
            </mat-form-field>
            <mat-form-field id="surnameField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.surname' | translate }}</mat-label>
                <input type="text" matInput placeholder="{{ 'dottnet.label.surname' | translate }}" [formControl]="surname" />
                <mat-error>{{ errorMessage('personalInfos.surname') }}</mat-error>
            </mat-form-field>
        </div>
        <div class="flex-row form-group--row from-group--row-wrapper gender-birthdate-wrapper">
            <mat-radio-group id="genderRadioGroup" class="flex-col flex-row-100 flex-justify-center flex-align-center form-radios mobile-form-field" [formControl]="gender">
                <mat-label>{{ 'dottnet.label.gender' | translate }}</mat-label>
                <div class="flex-row radio-gender-wrapper">
                    <mat-radio-button value="M">
                        {{ 'dottnet.label.gender.M' | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="F">
                        {{ 'dottnet.label.gender.F' | translate }}
                    </mat-radio-button>
                </div>
                @if (ngForm.submitted) {
                <mat-error>{{ errorMessage('personalInfos.gender') }}</mat-error>
                }
            </mat-radio-group>
            <mat-form-field id="birthdateField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.birthdate' | translate }}</mat-label>
                <input matInput [matDatepicker]="datePicker" placeholder="{{'dottnet.placeholder.date' | translate }}" [formControl]="birthdate" />
                <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
                <mat-error>{{ errorMessage('personalInfos.birthdate') }}</mat-error>
            </mat-form-field>
        </div>
        <div class="flex-row form-group--row from-group--row-wrapper birthplace-wrapper">
            <mat-radio-group id="bornAbroadRadioGroup" class="flex-col flex-row-100 flex-justify-center flex-align-center form-radios mobile-form-field" [formControl]="bornAbroad" (change)="manageBirthplaceField()">
                <mat-label>{{ 'dottnet.label.birthplace.question' | translate }}</mat-label>
                <div class="flex-row birthplace-question-group">
                    <mat-radio-button value="1">
                        {{ 'dottnet.label.yes' | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="0">
                        {{ 'dottnet.label.no' | translate }}
                    </mat-radio-button>
                </div>
                @if (ngForm.submitted) {
                <mat-error>{{ errorMessage('personalInfos.bornAbroad') }}
                </mat-error>
                }
            </mat-radio-group>
            <mat-form-field id="birthplaceField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.birthplace' | translate }}</mat-label>
                <input type="text" placeholder="{{ 'dottnet.label.birthplace' | translate }}" matInput [formControl]="birthplace" (input)="onPlaceChange($event)" [matAutocomplete]="autoCity" />
                <mat-autocomplete autoActiveFirstOption #autoCity="matAutocomplete" [displayWith]="displayCity.bind(this)">
                    @for (option of cityOptions(); track option) {
                    <mat-option [value]="option">
                        {{ option.descrizioneComune }}
                    </mat-option>
                    }
                </mat-autocomplete>
                <mat-error>{{ errorMessage('personalInfos.birthplace') }}</mat-error>
            </mat-form-field>
        </div>
        <div class="flex-row flex-justify-center flex-align-center form-group--row codice-fiscale-wrapper">
            <mat-form-field id="codiceFiscale" class="flex-row-100 mobile-form-field" [ngClass]="{'readonly-field': bornAbroad.value === '0' || bornAbroad.value === null}">
                <mat-label>{{ 'dottnet.label.codiceFiscale' | translate }}</mat-label>
                <input type="text" matInput placeholder="{{ 'dottnet.label.codiceFiscale' | translate }}" [formControl]="codiceFiscale" [readonly]="bornAbroad.value === '0' || bornAbroad.value === null" />
                <mat-error>{{ errorMessage('personalInfos.codiceFiscale') }}</mat-error>
            </mat-form-field>
        </div>
        </mat-expansion-panel>
        }
    </div>
    } @if (showProfessional()) {
    <div class="flex-col flex-justify-center flex-align-stretch form-group professional-infos-form-group" [formGroup]="professionalInfos">
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'dottnet.label.professionalInfos' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
        <div class="flex-row form-group--row from-group--row-wrapper category-specialty-wrapper">
            <mat-form-field id="categoryField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.category' | translate }}</mat-label>
                <input type="text" placeholder="{{ 'dottnet.label.category' | translate }}" matInput [formControl]="category" [matAutocomplete]="autoCategory" />
                <mat-autocomplete autoActiveFirstOption #autoCategory="matAutocomplete" [displayWith]="displayCategory.bind(this)" (optionSelected)="manageCategoryFields()">
                    @for (option of categoryFilteredOptions$ | async; track option) {
                    <mat-option [value]="option">
                        {{ option.descrizioneCategoria }}
                    </mat-option>
                    }
                </mat-autocomplete>
                <mat-error>{{ errorMessage('professionalInfos.category') }}</mat-error>
            </mat-form-field>
            @if (isDoctorSelected()) {
            <mat-form-field id="specialtyField" class="flex-row-100 mobile-form-field">
                <mat-label>{{ 'dottnet.label.specialty' | translate }}</mat-label>
                <input type="text" placeholder="{{ 'dottnet.label.specialty' | translate }}" matInput [formControl]="specialty" [matAutocomplete]="autoSpecialty" />
                <mat-autocomplete autoActiveFirstOption #autoSpecialty="matAutocomplete" [displayWith]="displaySpecialty.bind(this)" (optionSelected)="onSpecChange($event)">
                    @for (option of specialtyFilteredOptions$ | async; track option) {
                    <mat-option [value]="option">
                        {{ option.descrizioneSpecializzazione }}
                    </mat-option>
                    }
                </mat-autocomplete>
                <mat-error>{{ errorMessage('professionalInfos.specialty') }}</mat-error>
            </mat-form-field>
            }
        </div>
        @if (areShownCategoryFields()) {
        <div class="form-group flex-col flex-justify-center flex-align-start" [formGroup]="registerForm">
            <div class="flex-row form-group--row from-group--row-wrapper register-number-city-wrapper">
                <mat-form-field id="registerNumberField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.registerNumber' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'dottnet.label.registerNumber' | translate }}" [formControl]="registerNumber" />
                    <mat-error>{{ errorMessage('professionalInfos.registerForm.registerNumber') }}</mat-error>
                </mat-form-field>
                <mat-form-field id="registerCityField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.registerCity' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.registerCity' | translate }}" matInput [formControl]="registerProvince" [matAutocomplete]="autoProvince" />
                    <mat-autocomplete autoActiveFirstOption #autoProvince="matAutocomplete" [displayWith]="displayProvince.bind(this)">
                        @for (option of provinceFilteredOptions$ | async; track option) {
                        <mat-option [value]="option">
                            {{ option.descrizioneProvincia }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                    @if (componentForm.invalid && componentForm.touched) {
                    <mat-error>
                        {{ errorMessage('professionalInfos.registerForm.registerProvince') }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        }
        </mat-expansion-panel>
    </div>
    } @if (showEcm()) {
    <div class="form-group flex-col flex-justify-center flex-align-stretch" [formGroup]="ecmInfos" id="ecm">
        <div>
            <mat-checkbox (change)="setEcmChecked()" class="check-box" [checked]="isecmCheckedInternal()">{{ 'dottnet.label.ecm' | translate }} </mat-checkbox>
        </div>
        @if (isecmCheckedInternal()) {
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'dottnet.label.ecmInfos' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="flex-row form-group--row from-group--row-wrapper ecm-wrapper">
                <mat-form-field id="cellulareField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.cellulare' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.cellulare' | translate }}" matInput formControlName="cellulare" />
                    <mat-error>{{ errorMessage('ecmInfos.cellulare') }}</mat-error>
                </mat-form-field>
                <mat-form-field id="capField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.cap' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.cap' | translate }}" matInput [formControl]="cap" />
                    <mat-error>{{ errorMessage('ecmInfos.cap') }}</mat-error>
                </mat-form-field>
            </div>
            <div class="flex-row form-group--row from-group--row-wrapper professionType-wrapper">
                <mat-form-field id="professionplaceField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.professionplace' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.professionplace' | translate }}" matInput [formControl]="professionPlace" (input)="onPlaceChange($event)" [matAutocomplete]="autoProfessionCity" />
                    <mat-autocomplete autoActiveFirstOption #autoProfessionCity="matAutocomplete" [displayWith]="displayCity.bind(this)">
                        @for (option of cityOptions(); track option) {
                        <mat-option [value]="option">
                            {{ option.descrizioneComune }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                    <mat-error>{{ errorMessage('ecmInfos.professionPlace') }}</mat-error>
                </mat-form-field>
                <mat-form-field id="professiontypeField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.professionType' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.professionType' | translate }}" matInput [formControl]="professionType" [matAutocomplete]="autoProfessionType" />
                    <mat-autocomplete autoActiveFirstOption #autoProfessionType="matAutocomplete" [displayWith]="displayProfessionType.bind(this)">
                        @for (option of professionTypesOptions(); track option) {
                        <mat-option [value]="option">
                            {{ option.descrizioneTipoProfessione }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                    <mat-error>{{ errorMessage('ecmInfos.professionPlace') }}</mat-error>
                </mat-form-field>
            </div>
            <div class="flex-row form-group--row from-group--row-wrapper agenasdisciplineType-wrapper">
                <mat-form-field id="agenasdisciplinetypeField" class="flex-row-100 mobile-form-field">
                    <mat-label>{{ 'dottnet.label.agenasdisciplineType' | translate }}</mat-label>
                    <input type="text" placeholder="{{ 'dottnet.label.agenasdisciplineType' | translate }}" matInput [formControl]="agenasDisciplineType" [matAutocomplete]="autoAgenasDisciplineType" />
                    <mat-autocomplete autoActiveFirstOption #autoAgenasDisciplineType="matAutocomplete" [displayWith]="displayAgenasDisciplineType.bind(this)">
                        @for (option of agenasDisciplineTypesOptions(); track option) {
                        <mat-option [value]="option">
                            {{ option.descrizioneDisciplinaAgenas }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                    <mat-error>{{ errorMessage('ecmInfos.professionPlace') }}</mat-error>
                </mat-form-field>
            </div>
        </mat-expansion-panel>
        }
    </div>
    } @if (showConsents()) {
    <div class="flex-col flex-justify-center flex-align-stretch form-group consents-from-group" [formGroup]="consentsForm" id="consensi">
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'dottnet.wall.consensi' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
        <h4>
            {{ 'dottnet.userform.intro' | translate }}
            <a [href]="imprintUrl" target="_blank">{{ 'dottnet.userform.condition' | translate }}</a>. {{ 'dottnet.userform.intro2' | translate }}
            <a [href]="privacyPolicyUrl" target="_blank">{{ 'dottnet.userform.privacy' | translate }}</a> {{ 'dottnet.userform.intro3' | translate }}
        </h4>
        <div class="flex-row flex-justify-space-between flex-align-center form-group--radio-wrapper consents-row-wrapper">
            <mat-label class="flex-row flex-justify-start flex-align-center consents-label">
                {{ 'dottnet.label.consents.marketing' | translate }}
                <mat-icon (click)="openDialog('marketing')"> info_outline</mat-icon>
            </mat-label>
            <mat-radio-group class="consents-options" [formControl]="marketing" id="mktRadioGroup">
                <mat-radio-button value="1">{{ 'dottnet.consents.accept' | translate }}</mat-radio-button>
                <mat-radio-button value="0">{{ 'dottnet.consents.reject' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="flex-row flex-justify-space-between flex-align-center form-group--radio-wrapper consents-row-wrapper">
            <mat-label class="flex-row flex-justify-start flex-align-center consents-label">{{ 'dottnet.label.consents.profiling' | translate }}
                <mat-icon (click)="openDialog('profiling')"> info_outline</mat-icon>
            </mat-label>
            <mat-radio-group class="consents-options" [formControl]="profiling" id="prfRadioGroup">
                <mat-radio-button value="1">{{ 'dottnet.consents.accept' | translate }}</mat-radio-button>
                <mat-radio-button value="0">{{ 'dottnet.consents.reject' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="flex-row flex-justify-space-between flex-align-center form-group--radio-wrapper consents-row-wrapper">
            <mat-label class="flex-row flex-justify-start flex-align-center consents-label">{{ 'dottnet.label.consents.marketingThirdParties' | translate }}
                <mat-icon (click)="openDialog('marketingThirdParties')">info_outline</mat-icon>
            </mat-label>
            <mat-radio-group class="consents-options" [formControl]="marketingThirdParties" id="mktTrzRadioGroup">
                <mat-radio-button value="1">{{ 'dottnet.consents.accept' | translate }}</mat-radio-button>
                <mat-radio-button value="0">{{ 'dottnet.consents.reject' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="flex-row flex-justify-space-between flex-align-center form-group--radio-wrapper consents-row-wrapper">
            <mat-label class="flex-row flex-justify-start flex-align-center consents-label">{{ 'dottnet.label.consents.profilingThirdParties' | translate }}
                <mat-icon (click)="openDialog('profilingThirdParties')"> info_outline</mat-icon>
            </mat-label>
            <mat-radio-group class="consents-options" [formControl]="profilingThirdParties" id="prfTrzRadioGroup">
                <mat-radio-button value="1">{{ 'dottnet.consents.accept' | translate }}</mat-radio-button>
                <mat-radio-button value="0">{{ 'dottnet.consents.reject' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        @if (showTracking()) {
        <div class="flex-row flex-justify-space-between flex-align-center form-group--radio-wrapper consents-row-wrapper">
            <mat-label class="flex-row flex-justify-start flex-align-center consents-label">{{ 'dottnet.label.consents.tracking' | translate }}
                <mat-icon (click)="openDialog('tracking')"> info_outline</mat-icon>
            </mat-label>
            <mat-radio-group class="consents-options" [formControl]="tracking" id="trkRadioGroup">
                <mat-radio-button value="1">{{ 'dottnet.consents.accept' | translate }}</mat-radio-button>
                <mat-radio-button value="0">{{ 'dottnet.consents.reject' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        }
        @if (ngForm.submitted && !consentsForm.valid) {
        <mat-error>{{ errorMessage('consentsForm') }}
        </mat-error>
        }
        </mat-expansion-panel>
    </div>
    }
    <div class="flex-row form-button-container">
        @if (user() && !showPwd() && showPersonal()) {
        <button type="button" id="changePasswordButton" (click)="changePassword()" mat-raised-button color="accent">
            {{ 'dottnet.button.changePassword' | translate }}
        </button>
        }
        <span class="flex-row-100"></span>
        <button mat-raised-button color="accent" type="submit" [disabled]="isSubmitting()">
      {{ 'dottnet.button.save' | translate }}
    </button>
    </div>
</form>
